"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleScreen = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var auctions_1 = require("./pages/auctions/auctions");
var app_icon_black_png_1 = __importDefault(require("../assets/app_icon_black.png"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
// import { AutocompleteControl } from "doshx_controls_web";
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_redux_1 = require("react-redux");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var user_1 = require("../reducers/slices/user");
var lots_1 = require("./pages/lots/lots");
var bids_1 = require("./pages/bids/bids");
var users_1 = require("./pages/users/users");
var bidders_1 = require("./pages/bidders/bidders");
var general_1 = require("./pages/general/general");
var home_1 = require("./pages/home/home");
var auction_1 = require("../reducers/slices/auction");
var get_all_auctions_1 = require("../api/calls/auction/v3/get_all_auctions");
var doshx_controls_web_1 = require("doshx_controls_web");
var main_1 = require("../reducers/slices/main");
var reporting_1 = require("./pages/reporting/reporting");
var clients_1 = require("./pages/clients/clients");
var client_1 = require("../reducers/slices/client");
var automated_admin_1 = require("./pages/live/automated_admin/automated_admin");
var console_1 = require("../reducers/slices/console");
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
var manual_admin_1 = require("./pages/live/manual_admin/admin/manual_admin");
var manual_auctioneer_1 = require("./pages/live/manual_admin/auctioneer/manual_auctioneer");
var get_client_1 = require("../api/calls/client/get_client");
var ConsoleScreen = function (props) {
    var _a, _b;
    var cookies = new universal_cookie_1.default();
    var main = (0, react_redux_1.useSelector)(function (state) { return state.mainState; }).main;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }), clients = _c.clients, selectedClient = _c.selectedClient;
    var preserved_scroll = (0, react_redux_1.useSelector)(function (state) { return state.scrollState; }).preserved_scroll;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var auctions = (0, react_redux_1.useSelector)(function (state) { return state.auctionState; }).auctions;
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    var _d = (0, react_1.useState)(pathname), currentRoute = _d[0], setCurrentRoute = _d[1];
    var contentRef = (0, react_1.useRef)(null);
    // pathname & scrollposition for it
    // const [scrollPosition, setScrollPosition] = useState({});
    // useScrollRestoration(contentRef);
    (0, react_1.useEffect)(function () {
        var cookieUser = cookies.get("user");
        console.log("cookieUser", cookieUser);
        if (cookieUser) {
            dispatch((0, user_1.setUser)(__assign({}, cookieUser)));
        }
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (user && ((_a = user.admin) === null || _a === void 0 ? void 0 : _a.entity_id)) {
            if (user.admin.role == "super_admin") {
                dispatch((0, client_1.get_all_clients_thunk)());
            }
            else {
                (0, get_client_1.get_client)({
                    entity_id: user.admin.client_entity_id,
                }).then(function (response) {
                    if (response.data.success) {
                        dispatch((0, client_1.setSelectedClient)(response.data.content));
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Failed to retrieve the client for your admin user! Please contact support.",
                            messages: [response.data.message],
                        }));
                    }
                });
            }
        }
    }, [user]);
    (0, react_1.useEffect)(function () {
        if (selectedClient && selectedClient.entity_id) {
            dispatch((0, client_1.setSelectedClient)(selectedClient)); // keep track of the selected client when super_admin for what reason ... ? commenting this. # b74f36d
            console.log("selectedClient", selectedClient);
            (0, get_all_auctions_1.get_all_auctions)(selectedClient.entity_id).then(function (response) {
                if (response.data.success) {
                    dispatch((0, auction_1.setAuctions)(response.data.content));
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Failed to get all auctions", messages: [response.data.message] }));
                }
            });
        }
    }, [selectedClient]);
    (0, react_1.useEffect)(function () {
        if (contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) {
            console.log("scrolling - preserved path scroll", preserved_scroll[pathname]);
            // contentRef.current.scrollTop = scrollPosition;
            if (preserved_scroll[pathname]) {
                // delay before scroll
                setTimeout(function () {
                    contentRef === null || contentRef === void 0 ? void 0 : contentRef.current.scrollTo({ top: preserved_scroll[pathname] });
                }, 500);
            }
        }
    }, [pathname]);
    var menuItems = [
        // { icon: faUserTie, label: "Clients", route: "/clients" }, //
        { icon: pro_solid_svg_icons_1.faGavel, label: "Auctions", route: "/auctions" },
        { icon: pro_solid_svg_icons_1.faCubes, label: "Lots", route: "/lots" },
        { icon: pro_solid_svg_icons_1.faChartBar, label: "Reporting", route: "/reporting" },
        { icon: pro_solid_svg_icons_1.faUserTag, label: "Bidders", route: "/bidders" },
        { icon: pro_solid_svg_icons_1.faUsers, label: "Users", route: "/users" }, //
        // { icon: faTags, label: "Bids", route: "/bids" }, //
        // { icon: faCog, label: "General", route: "/general" }, // this is now inside the client tabs
    ];
    if (user.admin.role == "super_admin") {
        menuItems.unshift({ icon: pro_solid_svg_icons_1.faUserTie, label: "Clients", route: "/clients" });
    }
    else {
        menuItems.unshift({ icon: pro_solid_svg_icons_1.faUserTie, label: "Client Details", route: "/clients/client/".concat(user.admin.client_entity_id) });
    }
    if ((_a = mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.automated) === null || _a === void 0 ? void 0 : _a.enabled) {
        menuItems.unshift({ icon: pro_solid_svg_icons_1.faRobot, label: "Automated Admin", route: "/automated_admin" });
    }
    else if (!mainAuction || ((_b = mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.automated) === null || _b === void 0 ? void 0 : _b.enabled) ? false : true) {
        menuItems.unshift({ icon: pro_solid_svg_icons_1.faBroadcastTower, label: "Live Admin", route: "/manual_admin" });
        menuItems.unshift({ icon: pro_solid_svg_icons_1.faSignal, label: "Live Auctioneer", route: "/manual_auctioneer" });
    }
    return (react_1.default.createElement("div", { className: "flex flex-row w-full" },
        react_1.default.createElement("div", { className: "flex-none" },
            react_1.default.createElement(doshx_controls_web_1.SideHeaderControl, { logo: {
                    image: app_icon_black_png_1.default,
                    size: "small",
                    onClick: function () {
                        // navigate("/console/home");
                    },
                }, title: {
                    label: "Chant Lab Console",
                    // size: "large",
                }, 
                // logoPosition=""
                colors: {
                    content: {
                        backgroundColor: "bg-darkish",
                    },
                    logo: {
                        backgroundColor: "bg-black",
                    },
                    title: {
                        textColor: "text-white",
                    },
                }, 
                // isDrawerOpen={true}
                currentRoute: currentRoute, customSection: react_1.default.createElement("div", { className: "mx-2 px-2 py-2 my-2 flex flex-col gap-4 bg-white rounded-lg" },
                    user.admin.role == "super_admin" && (react_1.default.createElement(doshx_controls_web_1.AutocompleteControl, { placeholder: "Select Client", 
                        // textColor={"text-green-500"}
                        size: "medium", displayKey: "name", backgroundColor: "bg-[#F1F1F1]", options: clients, onSelectionChange: function (v) {
                            if (v) {
                                dispatch((0, client_1.setSelectedClient)(v));
                                if ((selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id) != (v === null || v === void 0 ? void 0 : v.entity_id)) {
                                    dispatch((0, console_1.setMainAuction)({}));
                                }
                            }
                            else {
                                dispatch((0, client_1.setSelectedClient)({}));
                                dispatch((0, console_1.setMainAuction)({}));
                            }
                        } })),
                    react_1.default.createElement(doshx_controls_web_1.AutocompleteControl, { placeholder: "Select Auction", 
                        // textColor={"text-green-500"}
                        size: "medium", displayKey: "title", backgroundColor: "bg-[#F1F1F1]", options: auctions, value: mainAuction, onSelectionChange: function (v) {
                            if (v) {
                                dispatch((0, console_1.setMainAuction)(v));
                            }
                            else {
                                dispatch((0, console_1.setMainAuction)({}));
                            }
                        } })), topMenu: {
                    size: "large",
                    items: menuItems,
                    colors: {
                        textColor: "text-white",
                        items: {
                            // backgroundColor: "bg-white",
                            indicatorColor: "bg-cyan-500",
                            hoverColor: "hover:bg-white",
                            backgroundColor: "bg-[#070720]",
                            selectedBackgroundColor: "bg-white",
                            expander: {
                                iconColor: "text-blue-500",
                                iconHoverColor: "group-hover:text-black",
                            },
                            // selected: {
                            //   // backgroundColor: "bg-white",
                            //   // textColor: "text-black",
                            //   iconColor: "text-black",
                            // },
                            icon: {
                                color: "text-blue-500",
                                hoverColor: "group-hover:text-black",
                                selectedColor: "text-black",
                            },
                            text: {
                                color: "text-white",
                                hoverColor: "group-hover:text-black",
                                selectedColor: "text-black",
                            },
                            count: {
                                backgroundColor: "bg-green-500",
                                textColor: "text-black",
                            },
                        },
                    },
                }, onMenuItemClick: function (menuItem) {
                    var _a;
                    navigate("/console".concat(menuItem.route));
                    setCurrentRoute((_a = menuItem.route) !== null && _a !== void 0 ? _a : "nothingmatchesthis");
                } })),
        react_1.default.createElement("div", { className: "flex flex-col w-full h-full space-y-2 pt-2 pl-4 pr-4 bg-light" },
            react_1.default.createElement("div", { className: "h-12 flex-none flex justify-end" },
                react_1.default.createElement("div", { className: "h-full border-l border-lighter flex items-center space-x-4 pl-4 cursor-pointer hover:underline", onClick: function () {
                        dispatch((0, main_1.setDrawerOpen)(true));
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUser, size: "xl" }),
                    react_1.default.createElement("div", { className: "font-bold" }, user.admin.email),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faChevronRight, size: "xl" }))),
            react_1.default.createElement("div", { className: "w-full h-full pb-4 overflow-hidden" },
                react_1.default.createElement("div", { ref: contentRef, className: "bg-white drop-shadow-lg w-full h-full overflow-y-auto" },
                    react_1.default.createElement(react_router_dom_1.Routes, null,
                        react_1.default.createElement(react_router_dom_1.Route, { index: true, element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "".concat(pathname, "/auctions") }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/home/*", element: react_1.default.createElement(home_1.HomeScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/automated_admin/*", element: react_1.default.createElement(automated_admin_1.AutomatedAdminScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/manual_auctioneer/*", element: react_1.default.createElement(manual_auctioneer_1.ManualAuctioneerScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/manual_admin/*", element: react_1.default.createElement(manual_admin_1.ManualAdminScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/auctions/*", element: react_1.default.createElement(auctions_1.AuctionsScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/lots/*", element: react_1.default.createElement(lots_1.LotsScreen, { scrollRef: contentRef }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/bids/*", element: react_1.default.createElement(bids_1.BidsScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/users/*", element: react_1.default.createElement(users_1.UsersScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/bidders/*", element: react_1.default.createElement(bidders_1.BiddersScreen, { scrollRef: contentRef }) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/reporting/*", element: react_1.default.createElement(reporting_1.ReportingPage, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/clients/*", element: react_1.default.createElement(clients_1.ClientsScreen, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/general/*", element: react_1.default.createElement(general_1.GeneralScreen, null) }))))),
        react_1.default.createElement(doshx_controls_web_1.DrawerControl, { open: main.isDrawerOpen, close: {
                backgroundColor: "bg-blue-600",
            }, toggleOpen: function (v) {
                dispatch((0, main_1.setDrawerOpen)(v));
            } },
            react_1.default.createElement("div", { className: "w-96 pt-20" },
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Log Out", textColor: "text-black", onClick: function () {
                        cookies.remove("user");
                        dispatch((0, main_1.setDrawerOpen)(false));
                        dispatch((0, client_1.setSelectedClient)(null)); // If we dont do this its possible that we can load the wrong auctions next time we log in
                        dispatch((0, user_1.setUser)(__assign(__assign({}, user), { token: "", client_token: null, admin: __assign(__assign({}, user.admin), { password: "" }) })));
                        navigate("/login");
                    } }))),
        react_1.default.createElement(react_toastify_1.ToastContainer, null)));
};
exports.ConsoleScreen = ConsoleScreen;
